if (window.jQuery) {
    window.jQuery(function ($) {

        function clearButtonClicked() {
            var $searchDiv = $('#mobile-search-div');
            $('input', $searchDiv).val('');
            $searchDiv.hide();
        }

        function searchClicked() {
            var $mobile = $('#mobile-search-div');
            var $input = $('input', $mobile);

            if ($mobile.is(':visible')) {
                $mobile.hide();
            } else {
                if($('#sidenav-overlay').length > 0){
                    $('.side-nav-activator').click();
                }
                $mobile.show();
                $input.focus();
            }
        }

        $('.mobile-search').on('click', searchClicked);
        $('.search-x').on('click', clearButtonClicked);

    });
} else TCT.jQueryWarning();
